'usr strict';

import controller from './techo_presupuestario.controller';
import template from './techo_presupuestario.html';

const techoPresupuestarioComponent = {
  bindings: {},
  controller,
  template
};

export default techoPresupuestarioComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/techos_presupuestarios/techo_presupuestario/techo_presupuestario.component.js